import {
  LandingPageCategory,
  LandingPageTargeting,
} from '@resources/lms-management/landing-page/types'

const emailDomainRegex = /^@[^\s@]+$/

export const validateWhitelistEmailDomains = async (
  _: unknown,
  value?: string[],
) => {
  if (!value || value.length === 0) return Promise.resolve()

  const invalidDomains = value.filter(
    (domain) => !emailDomainRegex.test(domain),
  )

  if (invalidDomains.length > 0) {
    return Promise.reject(
      new Error(`Domain email tidak valid: ${invalidDomains.join(', ')}`),
    )
  }

  return Promise.resolve()
}

type TargetingFields = {
  category?: LandingPageCategory
  provinceCodes?: string[]
  whitelistUsers?: string[]
  whitelistEmailDomains?: string[]
}

export const sanitizeLandingPageTargeting = <T extends TargetingFields>(
  values: T,
): Omit<T, 'provinceCodes' | 'whitelistUsers' | 'whitelistEmailDomains'> &
  Partial<LandingPageTargeting> => {
  const { provinceCodes, whitelistUsers, whitelistEmailDomains, ...rest } =
    values

  switch (values.category) {
    case 'PROVINCE':
      return { ...rest, provinceCodes }
    case 'WHITELIST_USER':
      return { ...rest, whitelistUsers }
    case 'WHITELIST_EMAIL_DOMAIN':
      return { ...rest, whitelistEmailDomains }
    default:
      return rest
  }
}
